// eqaul to firefox scrollbar-width: thin; webkit allows to define custom width
export const SCROLLBAR_WIDTH = 11;
